export default "__VITE_ASSET__Cm3E6k25__"